import { dedupeArrayValues } from 'owa-selected-calendars-utils';
import { getCalendarEntries, getAccountFromCalendarId } from 'owa-calendar-cache';
import { isConnectedAccount } from 'owa-accounts-store';
import { logUsage } from 'owa-analytics';
import { getAccountLoadState, CalendarEndpointType } from 'owa-calendar-cache-loader';

export function getAccountActiveCalendarIds(calendarIds: string[], userIdentity: string): string[] {
    // if userId is undefined then return empty
    if (!userIdentity) {
        return [];
    }
    const uniqueCalendarIds = dedupeArrayValues(calendarIds);
    const allCalendarIds = getCalendarEntries().map(calendar => calendar.calendarId.id);

    // remove non account calendars that may have been in input array
    const accountCalendarIds = uniqueCalendarIds?.filter(
        calendarId => getAccountFromCalendarId(calendarId) == userIdentity
    );

    // remove calendar ids belonging to the account but no longer in calendar cache
    const accountActiveCalendarIds = accountCalendarIds?.filter(calendarId =>
        allCalendarIds.includes(calendarId)
    );

    if (accountActiveCalendarIds?.length < uniqueCalendarIds?.length) {
        logUsage('board_calendarAsset_calendarIdPayloadCleanup', {
            isConnectedAccount: isConnectedAccount(userIdentity),
            inputLength: calendarIds.length,
            outputLength: accountActiveCalendarIds?.length,
        });
    }

    return accountActiveCalendarIds;
}

export function partitionIds(calendarIds: string[]) {
    const outlookIds: string[] = [];
    const groupsIds: string[] = [];

    calendarIds.forEach(id => {
        if (id.indexOf('@') > -1) {
            groupsIds.push(id);
        } else {
            outlookIds.push(id);
        }
    });
    return { outlookIds: outlookIds, groupsIds: groupsIds };
}

export function isAcccountFullyLoaded(
    userIdentity: string,
    accountEndpointIdsMap: {
        outlookIds: string[];
        groupsIds: string[];
    }
) {
    const isAccountFullyLoaded =
        ((accountEndpointIdsMap.outlookIds.length > 0 &&
            getAccountLoadState(userIdentity, CalendarEndpointType.Outlook)) ||
            accountEndpointIdsMap.outlookIds.length == 0) &&
        ((accountEndpointIdsMap.groupsIds.length > 0 &&
            getAccountLoadState(userIdentity, CalendarEndpointType.OutlookGroup)) ||
            accountEndpointIdsMap.groupsIds.length == 0);
    return isAccountFullyLoaded;
}
